import { useCallback } from "react";
import CascateList from "../../../../../../common/components/cascate_list";
import { EntregaObraParametros } from "../../../../domain/models/entrega_obra_parametros";

/**
 * StatisticsPanelEntregaObrasChecklist
 */

type Props = {
  entregaObraParametros: EntregaObraParametros

};

export const StatisticsPanelEntregaObrasChecklist = ({
  entregaObraParametros,

}: Props) => {


  const computeRatio = useCallback((total: number | null, index: number | null) => {
    let statistic = 0;
    if (total && index) {
      statistic = (index / total) * 100;
    }
    return statistic.toFixed(2);
  }, [
  ]);

  return (
    <CascateList title="Informações Gerais" defaultOpen={false}>
      <div className="w-full flex flex-col gap-2">
        <table className="table-auto mt-4">
          <thead>
            <tr>
              <th colSpan={5}></th>
              <th colSpan={5} className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white">Total</th>
            </tr>
          </thead>
          <thead>
            <tr>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white">Total Inspeções</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white">I. Aprovação(%)</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white">I. Retrabalho(%)</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white">I. Retrabalho Aprovado(%)</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white">I. Reprovação(%)</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white min-w-[3rem] max-w-[5rem]">NA</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white min-w-[3rem] max-w-[5rem]">A</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white min-w-[3rem] max-w-[5rem]">R</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white min-w-[3rem] max-w-[5rem]">RA</th>
              <th className="bg-[#e9edef] dark:bg-[#6a7981] text-black dark:text-white min-w-[3rem] max-w-[5rem]">X</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="bg-[#DCFDF7] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  {entregaObraParametros.totalInspecoes}
                </div>
              </td>
              <td className="bg-[#DCFDF7] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  <span>{computeRatio(entregaObraParametros.totalInspecoes, entregaObraParametros.totalA)} %</span>
                </div>
              </td>
              <td className="bg-[#DCFDF7] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  <span>{computeRatio(entregaObraParametros.totalInspecoes, entregaObraParametros.totalR)} %</span>
                </div>
              </td>
              <td className="bg-[#DCFDF7] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  <span>{computeRatio(entregaObraParametros.totalInspecoes, entregaObraParametros.totalRa)} %</span>
                </div>
              </td>
              <td className="bg-[#DCFDF7] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  <span>{computeRatio(entregaObraParametros.totalInspecoes, entregaObraParametros.totalX)} %</span>
                </div>
              </td>
              <td className="bg-[#8EA3DF] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  <span>{entregaObraParametros.totalNa}</span>
                </div>
              </td>
              <td className="bg-[#26c281] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  {entregaObraParametros.totalA}
                </div>
              </td>
              <td className="bg-[#ffff00] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  {entregaObraParametros.totalR}
                </div>
              </td>
              <td className="bg-[#ffb848] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  {entregaObraParametros.totalRa}
                </div>
              </td>
              <td className="bg-[#ef4836] h-[1.8rem]">
                <div className='size-full flex flex-row justify-center items-center font-bold'>
                  {entregaObraParametros.totalX}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </CascateList>
  );
}